<div class="c-card c-content c-content--xxl">
	<div class="o-grid">
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-60@md-and-up u-no-p">
            <div class="o-grid o-grid--wrap">
	                <div class="o-grid__cell o-grid__cell--w-10 u-no-p">
			            <img alt="CE mark" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/ce-mark.png" style="width:90px;"/>
			        </div>
			        <div class="o-grid__cell o-grid__cell--w-90">
	                    <p class="c-text c-text--sm c-text--bold">{{ 'Symptom_Check.Introduction.Disclaimer' | translate }}</p>
	                    <a href="https://infermedica.com/solutions/triage" target="_blank" class="c-text c-text--sm c-text--bold c-text--main">https://infermedica.com/solutions/triage</a>
	                </div>
            </div>
            <br/>
		
			<p class="c-text c-text--spaced u-osb-md">{{ 'Symptom_Check.Introduction.Intro' | translate }}</p>
			<form class="c-form" name="vm.form" #mainForm="ngForm">
				<div class="c-form__group u-osb-sm" [ngClass]="{'c-form__group--error': vm.submitted && tos.invalid}">
					<label class="c-checkbox">
						<input type="checkbox" name="tos" [(ngModel)]="vm.interview.consents.tos" #tos="ngModel" required>
						<span id="tosLabel">{{ 'Symptom_Check.Introduction.Tos_Consent' | translate }}</span>
					</label>
				</div>
				<div class="c-form__group u-osb-sm" [ngClass]="{'c-form__group--error': vm.submitted && emergency.invalid}">
					<label class="c-checkbox">
						<input type="checkbox" name="emergency" [(ngModel)]="vm.interview.consents.emergency" #emergency="ngModel" required>
						<span id="emergencyLabel">{{ 'Symptom_Check.Introduction.Emergency_Consent' | translate }}</span>
					</label>
				</div>
				<div class="c-form__group u-osb-sm" [ngClass]="{'c-form__group--error': vm.submitted && sharing.invalid}">
					<label class="c-checkbox">
						<input type="checkbox" name="sharing" [(ngModel)]="vm.interview.consents.sharing" #sharing="ngModel" required>
						<span id="dataSharingLabel">{{ 'Symptom_Check.Introduction.Data_Sharing_Consent' | translate }}</span>
					</label>
				</div>
			</form>
			<p class="c-text c-text--s3 u-ost-md" *ngIf="vm.submitted && mainForm.invalid">{{ 'Symptom_Check.Introduction.Consent_Error' | translate }}</p>
		</div>
		<div class="o-grid__cell o-grid__cell--w-40 u-hidden@up-to-md">
			<img alt="Consents step picture" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/consents.svg" aria-hidden="true" />
		</div>
	</div>
	<div class="o-grid u-ost-md">
		<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-pl">
			<button id="backButton" class="c-button c-button--link c-button--fit c-button--lg" type="button" (click)="vm.goBack($event)">{{ 'Common.Back' | translate }}</button>
		</div>
		<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up u-no-pr">
			<button id="submitButton" class="c-button c-button--s1 c-button--fit c-button--lg" type="button" (click)="vm.handleSubmit(mainForm)">{{ 'Common.Next' | translate }}</button>
		</div>
	</div>
</div>
